import { CreateSupplier, GetManySuppliersQueryParams, Supplier, SupplierPage, UpdateSupplier } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithEdit } from "./mixins/WithEdit";
import { WithSearchableGetPage } from "./mixins/WithSearchableGetPage";

export class Endpoint extends BaseEndpoint("suppliers") {
  getAll = (query?: GetManySuppliersQueryParams) => this.request("all", { query });
}

const withEdit = WithEdit<typeof Endpoint, Supplier, CreateSupplier, UpdateSupplier>(Endpoint);

export const SupplierEndpoint = WithSearchableGetPage<
  typeof withEdit,
  Supplier,
  SupplierPage,
  GetManySuppliersQueryParams
>(withEdit);
